import ProductSchema from './ProductSchema';
export default ProductSchema;
